export default "/_next/static/images/69/talk@2x-699dd6e2632fddc8490c0fb03416d82e.jpg";